export default __webpack_public_path__ + "static/media/logo.edbcd0f0.svg";